// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcessorSection_root__NDl0f","grid":"ProcessorSection_grid__Rk7vB","gif":"ProcessorSection_gif__nLf95"};